package io.github.jpuf.portfolio.pages.biospot

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*

@Page("/biospot/")
@Composable
fun PrivacypolicyPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("biospot/privacypolicy.md", mapOf("title" to listOf("BioSpot Privacy Policy"), "layout" to listOf(".components.layouts.MarkdownLayout")))) {
        com.varabyte.kobweb.compose.foundation.layout.Column {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("BioSpot Privacy Policy")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("This privacy policy applies to the BioSpot: Biodiversity Map app for mobile devices, together with any related services operated by James Bennett (collectively, the \"Application\"). James Bennett is hereby referred to as the \"Service Provider\".")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("What information does the Application obtain and how is it used?")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The Application does not collect, log, or store any personal information when you download and use it. Registration is not required. If the Application is used with an active internet connection, technical protocol data (such as your ephemeral IP address) is transmitted to facilitate network connectivity, but this data is not retained or used for tracking.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Does the Application collect precise real time location information of the device?")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("This Application does not collect precise information about the location of your mobile device.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Do third parties see and/or have access to information obtained by the Application?")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Since the Application does not collect any information, no data is shared with third parties.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("What are my opt-out rights?")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Since the Application does not collect personal information through normal use, uninstalling it simply removes the Application from your device.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you contact the Service Provider directly or voluntarily provide information by other means, you may request deletion of that information by contacting ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@biospot.uk") {
                    org.jetbrains.compose.web.dom.Text("contact@biospot.uk")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Children")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The Application is not intended for children under 16 years of age, or such higher age as required by applicable law. The Service Provider does not knowingly solicit data from children or market to them. Since the Application does not collect personal information through normal use, children's data is not at risk from use of the Application alone. If you voluntarily provide personal information through other means and are under 16 years of age, your parent or guardian must provide consent on your behalf where permitted by law.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Security")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Because the Application does not collect personal data, the risk of personal data exposure is minimal. However, no security system is completely secure. The Service Provider implements reasonable safeguards to protect systems and any data it holds.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Data Breach Notification")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Since the Application does not collect personal data through normal use, the risk of a data breach affecting your personal data is minimal. If a breach occurs involving any data you have voluntarily provided, the Service Provider will notify you as required by applicable law.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Changes")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The Service Provider may update this Privacy Policy from time to time. The Service Provider will notify you of material changes by posting the updated Privacy Policy with an effective date. Where required by law, the Service Provider will seek your consent to material changes before they take effect.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Previous versions of this Privacy Policy will be maintained and made available upon request by contacting the Service Provider at ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@biospot.uk") {
                    org.jetbrains.compose.web.dom.Text("contact@biospot.uk")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("This privacy policy is effective as of 2026-07-10")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Your Consent")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you voluntarily provide information to the Service Provider and processing is based on consent, you may withdraw that consent at any time without affecting processing carried out before withdrawal.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Contact Us")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@biospot.uk") {
                    org.jetbrains.compose.web.dom.Text("contact@biospot.uk")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
            com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
            org.jetbrains.compose.web.dom.P {
                com.varabyte.kobweb.compose.dom.GenericTag("span", null) {
                    org.jetbrains.compose.web.dom.Text("This privacy policy page was generated by")
                }
                org.jetbrains.compose.web.dom.Text(" ")
                com.varabyte.kobweb.silk.components.navigation.Link("https://app-privacy-policy-generator.nisrulz.com/") {
                    org.jetbrains.compose.web.dom.Text("App Privacy Policy Generator")
                }
            }
        }
    }
}
